/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { MetaDataFromJSON, MetaDataToJSON, } from './MetaData';
import { OrganisationListEntryFromJSON, OrganisationListEntryToJSON, } from './OrganisationListEntry';
import { PermissionDescriptorFromJSON, PermissionDescriptorToJSON, } from './PermissionDescriptor';
import { RoleListEntryFromJSON, RoleListEntryToJSON, } from './RoleListEntry';
import { UserListEntryFromJSON, UserListEntryToJSON, } from './UserListEntry';
/**
 * Check if a given object implements the AccessGrantResponse interface.
 */
export function instanceOfAccessGrantResponse(value) {
    var isInstance = true;
    isInstance = isInstance && "fromOrganisation" in value;
    return isInstance;
}
export function AccessGrantResponseFromJSON(json) {
    return AccessGrantResponseFromJSONTyped(json, false);
}
export function AccessGrantResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'fromOrganisation': OrganisationListEntryFromJSON(json['fromOrganisation']),
        'toUser': !exists(json, 'toUser') ? undefined : UserListEntryFromJSON(json['toUser']),
        'toOrganisation': !exists(json, 'toOrganisation') ? undefined : OrganisationListEntryFromJSON(json['toOrganisation']),
        'permissions': !exists(json, 'permissions') ? undefined : (json['permissions'].map(PermissionDescriptorFromJSON)),
        'roles': !exists(json, 'roles') ? undefined : (json['roles'].map(RoleListEntryFromJSON)),
        'metaData': !exists(json, 'metaData') ? undefined : MetaDataFromJSON(json['metaData'])
    };
}
export function AccessGrantResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'fromOrganisation': OrganisationListEntryToJSON(value.fromOrganisation),
        'toUser': UserListEntryToJSON(value.toUser),
        'toOrganisation': OrganisationListEntryToJSON(value.toOrganisation),
        'permissions': value.permissions === undefined ? undefined : (value.permissions.map(PermissionDescriptorToJSON)),
        'roles': value.roles === undefined ? undefined : (value.roles.map(RoleListEntryToJSON)),
        'metaData': MetaDataToJSON(value.metaData)
    };
}
